import { getCurrentUser } from 'aws-amplify/auth';

const getAuthenticatedUser = async () => {
    const { username } = await getCurrentUser();

    // Note that session will no longer contain refreshToken and clockDrift
    return {
        username,
    };
};
import { useState, useEffect } from 'react';

export type UserIsUserLoggedInReturnValue = {
    isUserLoggedIn: boolean | 'loading';
    recheckIsUserLoggedIn: () => void;
};

export function getIsUserLoggedIn(): Promise<boolean> {
    return getAuthenticatedUser()
        .then((user) => {
            return !!user;
        })
        .catch(() => {
            // if not authed, it can throw an unauthorized error
            return false;
        });
}

async function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export async function waitForUserLogout(): Promise<void> {
    let tryCount = 0;
    const maxTries = 200;
    const waitTime = 10;
    let isLoggedIn = true;
    do {
        isLoggedIn = await getIsUserLoggedIn();
        tryCount++;
        await sleep(waitTime);
    } while (tryCount < maxTries && isLoggedIn);
}

export const useIsUserLoggedIn = (): UserIsUserLoggedInReturnValue => {
    const [isUserLoggedIn, setIsUserLoggedIn] = useState<boolean | 'loading'>('loading');

    const recheckIsUserLoggedIn = () => {
        getIsUserLoggedIn()
            .then((isLoggedIn) => {
                setIsUserLoggedIn(isLoggedIn);
            })
            .catch((_e) => {
                setIsUserLoggedIn(false);
            });
    };
    useEffect(() => {
        recheckIsUserLoggedIn();
    }, []);

    return {
        isUserLoggedIn,
        recheckIsUserLoggedIn,
    };
};
